import FileTextIconOutlined from 'components/icons/FileTextIconOutlined';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const formTypeGuide: FeatureGuide = {
    key: 'formType',
    title: 'Form',
    icon: <FileTextIconOutlined />,
    sections: [
        whatItIs('The declaration form you want to create. Each form covers a different customs procedure.'),
        howItHelps(
            'Choosing the correct form up front applies the right fields and validation rules, so the declaration does not have to be recreated later.'
        ),
        tips([
            'If you are unsure, check the procedure agreed with your customer.',
            'The form type cannot be changed once the declaration is created.',
        ]),
    ],
};
